import { StoreSlice } from '../types';

export declare interface ISettingsPanelSlice {
  showSettingsPanel: boolean;
  showSettingsPanelToggler: boolean;
  showGameControlsPanel: boolean;
  showOptionsMenuPanel:boolean;
  currentSettingsMenuPanel: string | null;
  setCurrentSettingsMenuPanel: (v: string | null) => void;
  setShowSettingsPanelToggler: (v: boolean) => void;
  setShowSettingsPanel: (v: boolean) => void;
  setShowGameControlsPanel: (v: boolean) => void;
  setShowOptionsMenu: (v: boolean) => void;
  [key: string]: unknown;
}

const createSettingsPanelSlice: StoreSlice<ISettingsPanelSlice> = (set) => ({
  settingsPanelOpen: false,
  showSettingsPanel: false,
  showGameControlsPanel: false,
  showOptionsMenuPanel: false,
  showSettingsPanelToggler: true,
  currentSettingsMenuPanel: null,
  setCurrentSettingsMenuPanel: (v) => set((state) => { state.currentSettingsMenuPanel = v; }),
  setShowSettingsPanelToggler: (v) => set((state) => { state.showSettingsPanelToggler = v; }),
  setShowSettingsPanel: (v) => set((state) => { state.showSettingsPanel = v; }),
  setShowOptionsMenu: (v) => set((state) => { state.showOptionsMenu = v; }),
  setShowGameControlsPanel: (v) => set((state) => { state.showGameControlsPanel = v; }),
  // setPage: (v) => set((state) => { state.currentPage = v; }),
  // setPageTitle: (v) => set((state) => { state.pageTitle = v; }),
  // setUserId: (v) => set((state) => { state.userId = v; }),
  // setFoundError: (v) => set((state) => { state.foundError = v; })
});

export default createSettingsPanelSlice;
